import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { setCulture } from 'services/others';

import Header from './header';
import Hero from './hero';
import Features from './features';
import VideoIntroduction from './video-introduction';
import Pricing from './pricing';
import SecondaryFooter from './secondary-footer';
import Footer from './footer';

const Landing = () => {
  const { hash } = useLocation();

  useEffect(() => {
    const element = document.getElementById(hash.slice(1));
    element?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }, [hash]);

  const lang = (localStorage.getItem('language') || 'az').replace(/['"]/g, '');
  useEffect(() => {
    setCulture(lang);
  }, [lang]);

  return (
    <>
      <Header />
      <Hero />
      <Features />
      <VideoIntroduction />
      <Pricing />
      <SecondaryFooter />
      <Footer />
    </>
  );
};

export default Landing;
